import { EmptyStateBase } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export default function EmptyState() {
  const { t } = useTranslation();
  return (
    <EmptyStateBase
      emoji={":detective:"}
      title={t("common:empty")}
      description={t("common:create_new_item")}
    />
  );
}
